// extracted by mini-css-extract-plugin
export default {"location":"style_location__jkk0r"};